import { planFragment } from './plan-fragment';

export const availableUtilityPlansQuery = `
  query availableUtilityPlans {
    availableUtilityPlans {
      electric {
        recommended,
        recommendedReason,
        plan {
          ...${planFragment.name}
        }
      }
    }
  }
  ${planFragment.fragment}
`;
